<template>
	<el-dialog title="加入预警提醒" :visible.sync="dialogVisible" width="67.7%" :before-close="handleClose" class="add-alert" :close-on-click-modal="false">
		<div>
			<div class="table-div">
				<el-table
					v-loading="loading"
					:data="alerts"
					style="width:100%"
					max-height="320"
					stripe
					border
					:header-cell-style="{ background: '#e7ecf2', color: '#0092f1' }"
				>
					<el-table-column prop="title" header-align="center" align="center"  width="276" label="标题" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="url" header-align="center" align="center" width="276" label="链接" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="websiteName" header-align="center" align="center" label="网站名称" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="pageTime" header-align="center" align="center" label="发表时间" :show-overflow-tooltip="true"></el-table-column>
				</el-table>
				<div class="nodata table-nodata" v-if="totalRows === 0">
					<div class="nodataImg">
						<div class="textC ">
							<i class="iconfont iconwushuju wushuju-icon"></i>
							<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> -->
							</div>
						<div class="textC font14 nodataText">暂无数据！</div>
					</div>
				</div>
			</div>
			<div class="text-tips">
				<img src="~@/assets/img/tanchuang/yujing.png" alt="">最近已预警过类似舆情，是否继续预警?
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="confirm" class="btn confirm-btn btn-icon-flex">
				<!-- <img src="~@/assets/img/tanchuang/queding.png" alt="" /> -->
				<i class="iconfont iconqueding btn-icon"></i>
				<span>确 认</span>
			</el-button>
			<el-button type="primary" @click="cancel" class="btn cancel-btn btn-icon-flex">
				<!-- <img src="~@/assets/img/tanchuang/quxiao.png" alt="" /> -->
				<i class="iconfont iconguanbi btn-icon textColor btn-quxiao" ></i>
				<span>取 消</span>
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialogVisible: false,
			loading:false,
			totalRows:1,

		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose(done) {
			this.dialogVisible = false;
		},
		initPage() {},
		confirm() {
            this.$parent.singleEarly(this.item,1);
			this.dialogVisible = false;
		},
		cancel(){
			this.dialogVisible = false;
		},
	},
	watch: {
		dialogVisible: {
			handler: function(val, oldval) {},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	},
    props: {
        alerts: {
            type: Array
        },
        item:{
            type:Object
		}
    }
};
</script>

<style lang="less">
@import '~@/assets/css/page/global/addAlert.less';
</style>
